<template>
  <v-dialog v-model="popupDialog" width="50%" transition="dialog-bottom-transition">
    <v-card rounded="xl">
      <v-toolbar dense="dense" text="text" color="accent white--text">
        <v-toolbar-title>Upload Image</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text class="pa-4">
        <v-form @submit.prevent>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <vue-dropzone
                  id="dropzone"
                  ref="myVueDropzone"
                  :options="dropzoneOptions"
                  :duplicate-check="true"
                  @vdropzone-sending="sendingImage"
                  @vdropzone-success="fileUploaded"
                  @vdropzone-removed-file="fileRemoved"
                  @vdropzone-queue-complete="uploadFinished"
                >
                </vue-dropzone>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-7 pb-7">
        <v-spacer></v-spacer>
        <cs-button
          id="imageUploadCancelButton"
          label="Cancel"
          large
          @click="cancelImageUpload"
        ></cs-button>
        <cs-button
          id="uploadImageButton"
          label="Upload"
          :disabled="disableUpload"
          primary
          large
          @click="addImage"
        ></cs-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { CSBase } from '@complispace/cs-design-system';
import vueDropzone from 'dropzone-vue3';
import { mapGetters } from 'vuex';
import * as types from '@/store/mutationTypes';
import { content } from '@/api';

export default {
  name: 'TipTapImageUploadDialog',

  components: {
    vueDropzone
  },
  extends: CSBase,

  props: {
    showDialog: { type: Boolean, required: true, default: false },
    token: { type: String, required: true }
  },

  emits: ['onUpload', 'closed'],

  data() {
    return {
      popupDialog: false,
      dropzoneOptions: {
        url: content.getUploadImageURL(),
        autoProcessQueue: true,
        addRemoveLinks: true,
        uploadMultiple: false,
        thumbnailWidth: 200,
        acceptedFiles: '.jpeg,.jpg,.bmp,.png,.gif,.ico,.webP',
        dictDefaultMessage: 'Drag & Drop or Upload an image',
        dictInvalidFileType: 'Only jpeg, jpg, bmp, png, gif, ico, webP can be uploaded'
      },
      adding: false,
      hasUploadingContent: false
    };
  },

  watch: {
    showDialog(value) {
      if (value) {
        this.popupDialog = true;
      }
    },

    popupDialog(value) {
      if (!value) {
        this.$emit('closed');
      }
    }
  },

  computed: {
    ...mapGetters({
      getImageFromFile: 'imageUploader/getImageFromFile',
      getUploadedImages: 'imageUploader/getUploadedImages',
      hasUploadContentInDropzone: 'imageUploader/hasUploadContentInDropzone',
      getXSiteUrl: 'session/getXSiteURL',
      getSupportSiteUrl: 'session/getSupportSiteURL'
    }),

    disableUpload() {
      return this.hasUploadingContent || !this.hasUploadContentInDropzone();
    }
  },

  methods: {
    sendingImage(file, xhr) {
      xhr.open('POST', content.getUploadImageURL(), true);
      xhr.setRequestHeader('Authorization', `Bearer ${this.token}`);
      xhr.setRequestHeader('x-site-uri', this.getXSiteUrl());
      const supportSiteUrl = this.getSupportSiteUrl();
      if (supportSiteUrl) xhr.setRequestHeader('x-support-site-uri', supportSiteUrl);
      this.hasUploadingContent = true;
    },

    fileUploaded(file, response) {
      if (Object.prototype.hasOwnProperty.call(response, 'entityTag')) {
        const image = {
          hashCode: response.entityTag,
          file
        };
        this.$store.commit(types.IMAGE_UPLOADER_IMAGE_UPLOAD, image);
      }
    },

    fileRemoved(file) {
      if (!this.adding) {
        this.$store.commit(types.IMAGE_UPLOADER_IMAGE_REMOVE, file);
      }
      this.hasUploadingContent = false;
    },

    fileAdded(imageInfo) {
      this.$store.commit(types.IMAGE_UPLOADER_IMAGE_ADD, imageInfo);
    },

    uploadFinished() {
      this.hasUploadingContent = false;
    },

    addImage() {
      const images = this.getUploadedImages();
      this.$emit('onUpload', images);

      this.adding = true;
      images.forEach((image) => {
        this.fileAdded(image);
      });

      this.$refs.myVueDropzone.removeAllFiles();
      this.adding = false;
      this.popupDialog = false;
    },

    cancelImageUpload() {
      this.$refs.myVueDropzone.removeAllFiles();
      this.popupDialog = false;
    }
  }
};
</script>
